"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gender = void 0;
exports.getReducedName = getReducedName;
var Gender;
(function (Gender) {
    Gender["male"] = "Male";
    Gender["female"] = "Female";
    Gender["nonbinary"] = "Non-binary";
    Gender["notsay"] = "Prefer not to say";
})(Gender || (exports.Gender = Gender = {}));
/**
 * Returns a reduced name: first name plus the first letter of the last name (if present).
 * Example: ("john", "doe") => "John D"
 */
function getReducedName(firstName, lastName) {
    const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
    const trimmedFirst = (firstName || "").trim();
    const trimmedLast = (lastName || "").trim();
    if (!trimmedFirst && !trimmedLast) {
        return "";
    }
    if (!trimmedLast) {
        return capitalize(trimmedFirst);
    }
    return `${capitalize(trimmedFirst)} ${trimmedLast.charAt(0).toUpperCase()}`;
}
//# sourceMappingURL=fans.js.map